export function ProjetosRealizados() {
  const mainProjects = [
    {
      title: 'Circuito Hip-Hop pelas Comunidades',
      category: 'Cultura Urbana',
      description: 'Projeto itinerante de formação, apresentações e valorização da cultura urbana em territórios periféricos.',
      metrics: ['Artistas locais remunerados', 'Comunidades atendidas', 'Formação cultural'],
      image: 'https://readdy.ai/api/search-image?query=hip%20hop%20street%20performance%20in%20urban%20community%2C%20breakdancing%2C%20graffiti%20art%2C%20vibrant%20street%20culture%2C%20young%20artists%20performing%2C%20community%20gathering%2C%20energetic%20atmosphere%2C%20urban%20landscape%2C%20authentic%20street%20photography%2C%20golden%20hour%20lighting%2C%20cultural%20celebration&width=800&height=600&seq=projeto-hiphop&orientation=landscape'
    },
    {
      title: 'Feira Afro de Atitude',
      category: 'Economia Criativa',
      description: 'Plataforma de valorização do empreendedorismo afro-brasileiro e da economia criativa.',
      metrics: ['Empreendedores fortalecidos', 'Geração de renda', 'Integração cultural'],
      image: 'https://readdy.ai/api/search-image?query=african%20brazilian%20marketplace%20fair%2C%20colorful%20artisan%20products%2C%20cultural%20crafts%2C%20entrepreneurs%20selling%20handmade%20goods%2C%20vibrant%20market%20atmosphere%2C%20cultural%20heritage%20celebration%2C%20community%20commerce%2C%20warm%20lighting%2C%20authentic%20cultural%20photography&width=800&height=600&seq=projeto-feira-afro&orientation=landscape'
    }
  ];

  const secondaryProjects = [
    {
      title: 'Nego Festival',
      icon: 'ri-music-2-line',
      description: 'Festival cultural com foco em tecnologia, inovação e cultura urbana. Impacto juvenil e integração entre cultura e inovação.'
    },
    {
      title: 'Projetos Literários',
      icon: 'ri-book-open-line',
      description: 'Ações voltadas à literatura, formação cultural e produção audiovisual com alcance regional e nacional.'
    },
    {
      title: 'Produção Audiovisual',
      icon: 'ri-film-line',
      description: 'Criação de conteúdo audiovisual que valoriza narrativas culturais e promove visibilidade para artistas locais.'
    }
  ];

  return (
    <section id="projetos" className="py-32 px-8 lg:px-20 bg-dark relative">
      <div className="absolute left-8 top-1/2 -translate-y-1/2 hidden lg:block">
        <span className="text-gold text-xs uppercase tracking-[0.4em] font-semibold transform -rotate-90 inline-block whitespace-nowrap">
          Projetos Realizados
        </span>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20 space-y-4">
          <span className="text-gold text-xs uppercase tracking-[0.3em] font-semibold lg:hidden">
            Projetos Realizados
          </span>
          <h2 className="font-display text-5xl lg:text-6xl font-bold text-white">
            Nosso Impacto
          </h2>
        </div>

        <div className="space-y-6">
          <div className="grid md:grid-cols-2 gap-6">
            {mainProjects.map((project, index) => (
              <div
                key={index}
                className="relative h-[500px] rounded-3xl overflow-hidden group cursor-pointer"
              >
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                
                <div className="absolute bottom-0 left-0 right-0 p-8 space-y-4">
                  <span className="inline-block px-4 py-1 bg-gold text-black text-xs uppercase tracking-wider font-semibold rounded-full">
                    {project.category}
                  </span>
                  
                  <h3 className="text-3xl font-display font-bold text-white leading-tight">
                    {project.title}
                  </h3>
                  
                  <div className="flex flex-wrap gap-4">
                    {project.metrics.map((metric, idx) => (
                      <span key={idx} className="text-gold text-sm font-medium">
                        • {metric}
                      </span>
                    ))}
                  </div>
                  
                  <p className="text-gray-300 text-sm leading-relaxed">
                    {project.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {secondaryProjects.map((project, index) => (
              <div
                key={index}
                className="bg-dark-light rounded-3xl p-10 space-y-6 hover:bg-dark-lighter transition-colors duration-300 cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center">
                  <i className={`${project.icon} text-5xl text-gold`}></i>
                </div>
                
                <div className="text-center space-y-4">
                  <div className="text-6xl text-gold/20 font-display">"</div>
                  
                  <h3 className="text-2xl font-display font-semibold text-white">
                    {project.title}
                  </h3>
                  
                  <div className="w-8 h-px bg-gold mx-auto"></div>
                  
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {project.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-xl text-gold font-medium italic">
            O circuito transforma cultura em oportunidade real.
          </p>
        </div>
      </div>
    </section>
  );
}
